import { useEffect, useState } from 'react';

import { ReactComponent as EmptyBoxIcon } from '../../../../assets/svg/empty-box.svg';
import { Page } from '../../../../helbest';
import { API } from '../../../../request/api';
import OtpItem from './OtpItem/OtpItem';
import styles from './Otps.module.css';

const Otps = () => {
  const [data, setData] = useState([]);
  const [requestNumber, setRequestNumber] = useState(0);

  const getOtp = () => {
    API.get
      .checkOtpPage()
      .then((response) => {
        if (response.success) {
          setData(response.data);
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };
  useEffect(() => {
    setTimeout(() => {
      if (requestNumber < 20) {
        //send request
        getOtp();
        setRequestNumber(requestNumber + 1);
      }
    }, 20000);
  }, [requestNumber]);

  useEffect(() => {
    //send request
    getOtp();
  }, []);

  return (
    <Page
      address="/profile/"
      back
      className="page-profile"
      headerFix
      logo
      mobileContainer
      showFooter
      title="کدهای یکبار مصرف">
      {!!data && data.length === 0 ? (
        <div className={`${styles.EmptyContainer} ${styles.CenterBase}`}>
          <EmptyBoxIcon className={styles.EmptyBoxIcon} />
          <div className={styles.EmptyText}>کد یکبار مصرفی یافت نشد</div>
        </div>
      ) : null}

      <div className="factors-holder factors-scroll page-factor-factors-container">
        {/* map Otps */}
        {data?.map((otpItems, i) => (
          <OtpItem key={i} data={otpItems} order={otpItems.orders[0].order_id} />
        ))}
      </div>
    </Page>
  );
};

export default Otps;
